import { useSearchParams } from "react-router-dom";
import { AppHeader } from "@/components/layout/AppHeader";
import { NamtechFooter } from "@/components/poc/NamtechFooter";
import { ListPanel } from "@/components/finance/ListPanel";
import { InvestmentAlerts } from "@/components/finance/InvestmentAlerts";
import { InvestmentCard, LoanCard } from "@/components/finance/Cards";
import { INVESTMENT_FIELDS, LOAN_FIELDS } from "@/lib/finance";

const INV_ROWS = [
  { key: "committed", label: "Comprometido", strong: true },
  { key: "contributed", label: "Aportado" },
  { key: "returns", label: "Retornos" },
];
const LOAN_ROWS = [
  { key: "outstanding", label: "Saldo pendiente", strong: true },
  { key: "principal", label: "Capital prestado" },
  { key: "capital_paid", label: "Capital cobrado" },
  { key: "interest_paid", label: "Intereses cobrados" },
];

export default function FinancePage() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") === "prestamos" ? "prestamos" : "inversiones";
  const TabBtn = ({ id, label, testid }) => (
    <button data-testid={testid} onClick={() => setParams(id === "prestamos" ? { tab: id } : {}, { replace: true })}
      className={`flex-1 py-2.5 rounded-lg text-sm font-semibold transition-colors ${tab === id ? "bg-[var(--c-card)] shadow-sm c-accent" : "c-muted"}`}>
      {label}
    </button>
  );
  return (
    <div data-testid="finance-page" className="min-h-screen max-w-md mx-auto flex flex-col">
      <AppHeader eyebrow="Finanzas personales" title={tab === "prestamos" ? "Préstamos" : "Inversiones"} />
      <main className="flex-1 px-4 space-y-4">
        <div className="flex gap-1 p-1 rounded-xl bg-[var(--c-elev)]">
          <TabBtn id="inversiones" label="Inversiones" testid="inversiones-tab-investments" />
          <TabBtn id="prestamos" label="Préstamos" testid="inversiones-tab-loans" />
        </div>
        <InvestmentAlerts />
        {tab === "inversiones" ? (
          <ListPanel key="inv" endpoint="/investments" detailPath="/inversiones" fields={INVESTMENT_FIELDS} totalRows={INV_ROWS}
            createLabel="Nueva inversión" createTestid="create-investment-btn" Card={InvestmentCard} testid="investments-panel" />
        ) : (
          <ListPanel key="loan" endpoint="/loans" detailPath="/prestamos" fields={LOAN_FIELDS} totalRows={LOAN_ROWS}
            createLabel="Nuevo préstamo" createTestid="create-loan-btn" Card={LoanCard} testid="loans-panel" />
        )}
      </main>
      <div className="px-4"><NamtechFooter /></div>
    </div>
  );
}
